import { hideDialog } from '../../../react/features/base/dialog/actions';
import { PARTICIPANT_ROLE } from '../../../react/features/base/participants/constants';
import { setFilmstripVisible } from '../../../react/features/filmstrip/actions';
import { setGifMenuVisibility } from '../../../react/features/gifs/actions';
import {
    toggleReactionsMenuVisibility
} from '../../../react/features/reactions/actions';
import {
    openSettingsDialog
} from '../../../react/features/settings/actions';
import {
    SETTINGS_TABS
} from '../../../react/features/settings/constants';
import {
    setOverflowMenuVisible
} from '../../../react/features/toolbox/actions';
import { setTileView } from '../../../react/features/video-layout/actions';
import { ADVANCED_TAB_NAME } from '../../components/advanced-tab/constants';
import Env from '../../modules/Environment';

import {
    EXTERNAL_USER,
    NAVIGATION_FEATURE_TUTORIAL, NAVIGATION_FULL_TUTORIAL,
    WIZYCONF_HW_NAME, WIZYCONF_NAME, XBEES_NAME
} from './constants';


const sharedFullNavigationForAll = [
    'audio', 'video', 'shareScreen', 'chat',
    'raiseHand', 'reactions', 'sidebarSize',
    'pinParticipant', 'maxPinnedUsers', 'noiseSuppression'
];
const sharedFeatureNavigationForAll = [
    'popupNoiseSupp', 'morePiP', 'moreControlSharing'
];

export const tutorialNavigationConfig = {
    [WIZYCONF_NAME]: {
        [NAVIGATION_FULL_TUTORIAL]: [
            ...sharedFullNavigationForAll,
            'moreActions',
            'moreRecording',
            'moveVirtualBackground',
            'moreWhiteboard',
            'invitePeople',
            'headerPerformance',
            'popupModerator',
            'connectionStatus',
            'popupHints',
            'endConferenceForAll'
        ],
        [NAVIGATION_FEATURE_TUTORIAL]: [
            ...sharedFeatureNavigationForAll
        ]
    },
    [XBEES_NAME]: {
        [NAVIGATION_FULL_TUTORIAL]: [
            ...sharedFullNavigationForAll,
            'moreActions',
            'moreRecording',
            'moveVirtualBackground',
            'moreWhiteboard',
            'invitePeople',
            'headerPerformance',
            'connectionStatus',
            'toggleFullScreen',
            'conversationInfo',
            'popupHints',
            'endConferenceForAll'
        ],
        [NAVIGATION_FEATURE_TUTORIAL]: [
            'advanceTabAutoPip',
            ...sharedFeatureNavigationForAll
        ]
    },
    [EXTERNAL_USER]: {
        [NAVIGATION_FULL_TUTORIAL]: [
            ...sharedFullNavigationForAll,
            'moreActions',
            'moveVirtualBackground',
            'invitePeople',
            'headerPerformance',
            'connectionStatus'
        ],
        [NAVIGATION_FEATURE_TUTORIAL]: [
            ...sharedFeatureNavigationForAll
        ]
    },
    [WIZYCONF_HW_NAME]: {
        [NAVIGATION_FULL_TUTORIAL]: [
            'audio', 'video', 'chat', 'raiseHand', 'tileView'
        ],
        [NAVIGATION_FEATURE_TUTORIAL]: [
            'pinParticipant', 'whiteboard'
        ]
    }
};

export const listAllNavigations = {
    // base navigations
    'audio': {
        title: 'Mic',
        combineLangKey: [
            {
                key: 'addPermission',
                visibility: !Env.isWizyconf()
            },
            {
                key: 'audio',
                visibility: true
            },
            {
                key: 'selectAudioSource',
                visibility: !Env.isWizyconf()
            }
        ],
        'selector': [ '.audio-preview', '.audio-preview .settings-button-small-icon' ],
        'selectorTooltip': '.audio-preview',
        'tooltipPosition': {
            placement: 'top'
        }
    },
    'video': {
        title: 'Camera',
        combineLangKey: [
            {
                key: 'video',
                visibility: true
            },
            {
                key: 'selectVideoSource',
                visibility: !Env.isWizyconf()
            }
        ],
        'selector': [ '.video-preview', '.video-preview .settings-button-small-icon' ],
        'selectorTooltip': '.video-preview',
        'tooltipPosition': {
            placement: 'top'
        }
    },
    'shareScreen': {
        title: 'Share your screen.',
        'selector': '.toolbox-button.shareyourscreen',
        'tooltipPosition': {
            placement: 'top'
        }
    },
    'chat': {
        title: 'Chat',
        'selector': [ '.toolbox-button.openchat', '.toolbox-button.closechat' ],
        'tooltipPosition': {
            placement: 'top'
        }
    },
    'raiseHand': {
        title: 'Share attitude and feedback',
        'selector': [ '.toolbox-button.raisehand', '#reactions-menu-button' ],
        'tooltipPosition': {
            placement: 'top'
        }
    },
    'reactions': {
        title: 'Reactions',
        'selector': '.reactions-menu-container',
        'tooltipPosition': {
            placement: 'top'
        },
        runAction: [
            {
                actionDispatch: toggleReactionsMenuVisibility,
                actionName: 'toggleReactionsMenuVisibility',
                'transitionDelay': 200
            },
            {
                actionDispatch: setGifMenuVisibility,
                actionName: 'setGifMenuVisibility',
                params: false
            }
        ],
        closeAction: [
            {
                actionDispatch: toggleReactionsMenuVisibility,
                actionName: 'toggleReactionsMenuVisibility'
            }
        ]
    },
    'connectionStatus': {
        title: 'Connection status',
        'selector': '#participant-connection-indicator',
        'tooltipPosition': {
            placement: 'left-start'
        },
        toggleCustomClass: [
            {
                className: '#participant-connection-indicator',
                addClassName: 'display_inline-block',
                removeClassName: 'display_inline-block'
            }
        ],
        runAction: [
            {
                actionDispatch: setFilmstripVisible,
                actionName: 'setFilmstripVisible',
                params: true,
                transitionSelector: '.filmstrip',
                getSateFromStore: {
                    name: 'features/filmstrip',
                    value: 'visible'
                }
            },
            {
                actionDispatch: setTileView,
                actionName: 'setTileView',
                params: false,
                getSateFromStore: {
                    name: 'features/video-layout',
                    value: 'tileViewEnabled',
                    compareState: [ true, undefined ]
                },
                transitionDelay: 200
            }
        ]
    },
    'moreActions': {
        title: 'More Actions',
        'selector': '.toolbox-button.moreactions',
        'tooltipPosition': {
            placement: 'auto'
        }
    },
    'moreRecording': {
        'title': 'Start recording',
        'selector': '.popover .recording',
        'tooltipPosition': {
            placement: 'left'
        },
        scrollToElement: true,
        typeRole: PARTICIPANT_ROLE.MODERATOR,
        runAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: true,
                transitionDelay: 300,
                getSateFromStore: {
                    name: 'features/toolbox',
                    value: 'overflowMenuVisible',
                    compareState: false
                }
            }
        ],
        closeAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: false
            }
        ]
    },
    'moreMuteEveryone': {
        'title': 'Mute Everyone',
        'selector': '.context-menu .muteeveryone',
        'tooltipPosition': {
            placement: 'left'
        },
        scrollToElement: true,
        typeRole: PARTICIPANT_ROLE.MODERATOR,
        runAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: true,
                getSateFromStore: {
                    name: 'features/toolbox',
                    value: 'overflowMenuVisible',
                    compareState: false
                }
            }
        ],
        closeAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: false
            }
        ]
    },
    'moveVirtualBackground': {
        'title': 'Virtual background',
        'selector': '.popover .selectbackground',
        'tooltipPosition': {
            placement: 'left'
        },
        scrollToElement: true,
        runAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: true,
                transitionDelay: 300,
                getSateFromStore: {
                    name: 'features/toolbox',
                    value: 'overflowMenuVisible',
                    compareState: false
                }
            }
        ],
        closeAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: false
            }
        ]
    },
    'moreWhiteboard': {
        'title': 'Whiteboard',
        'selector': '.whiteboard',
        'tooltipPosition': {
            placement: 'left'
        },
        scrollToElement: true,
        runAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: true,
                transitionDelay: 300,
                getSateFromStore: {
                    name: 'features/toolbox',
                    value: 'overflowMenuVisible',
                    compareState: false
                }
            }
        ],
        closeAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: false
            }
        ]
    },
    'moreControlSharing': {
        'title': 'Control sharing',
        'selector': '.controlSharingButton',
        'tooltipPosition': {
            placement: 'left'
        },
        scrollToElement: true,
        runAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: true,
                transitionDelay: 300,
                getSateFromStore: {
                    name: 'features/toolbox',
                    value: 'overflowMenuVisible',
                    compareState: false
                }
            }
        ],
        closeAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: false
            }
        ]
    },
    'popupModerator': {
        'title': 'Moderator options',
        'selector': '#dialogtab-content-moderator-tab',
        'tooltipPosition': {
            placement: 'auto'
        },
        typeRole: PARTICIPANT_ROLE.MODERATOR,
        runAction: [
            {
                actionDispatch: openSettingsDialog,
                actionName: 'openSettingsDialog',
                params: SETTINGS_TABS.MODERATOR,
                transitionSelector: '.css-t2npoc-container'
            }
        ],
        closeAction: [
            {
                actionDispatch: hideDialog,
                actionName: 'hideDialog'
            }
        ]
    },
    'moreShortcutsBtn': {
        'selector': '.shortcuts',
        'tooltipPosition': {
            placement: 'auto'
        },
        scrollToElement: true,
        runAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: true,
                transitionDelay: 300,
                getSateFromStore: {
                    name: 'features/toolbox',
                    value: 'overflowMenuVisible',
                    compareState: false
                }
            }
        ],
        closeAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: false
            }
        ]
    },
    'morePiP': {
        title: 'Picture In Picture mode',
        'selector': '.pictureInPicture',
        'tooltipPosition': {
            placement: 'auto'
        },
        scrollToElement: true,
        runAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: true,
                transitionDelay: 300,
                getSateFromStore: {
                    name: 'features/toolbox',
                    value: 'overflowMenuVisible',
                    compareState: false
                }
            }
        ],
        closeAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: false
            }
        ]
    },

    'tileView': {
        title: 'Toggle tile view',
        'selector': '.toolbox-button.tileview',
        'tooltipPosition': {
            placement: 'auto'
        }
    },
    'invitePeople': {
        title: 'Invite people',
        'selector': [ '.toolbox-button.participants', '.toolbox-button.participants + [class*="-badge"]' ],
        'tooltipPosition': {
            placement: 'auto'
        }
    },
    'headerPerformance': {
        title: 'Performance settings',
        'selector': '#videoResolutionLabel',
        'tooltipPosition': {
            placement: 'auto'
        },
        runAction: [
            {
                actionDispatch: setTileView,
                actionName: 'setTileView',
                params: false,
                getSateFromStore: {
                    name: 'features/video-layout',
                    value: 'tileViewEnabled',
                    compareState: [ true, undefined ]
                }
            }
        ]
    },
    'toggleFullScreen': {
        title: 'Full screen',
        'selector': '.toolbox-content .button-fullscreen',
        'tooltipPosition': {
            placement: 'right-end'
        }
    },
    'conversationInfo': {
        title: 'Conversation info',
        'selector': '.button-info',
        'tooltipPosition': {
            placement: 'left-start'
        }
    },

    // new feature navigations
    'popupHints': {
        title: 'Sales conversations hints',
        'selector': '.hints-tab',
        'tooltipPosition': {
            placement: 'auto'
        },
        scrollToElement: true,
        typeRole: PARTICIPANT_ROLE.MODERATOR,
        runAction: [
            {
                actionDispatch: openSettingsDialog,
                actionName: 'openSettingsDialog',
                params: ADVANCED_TAB_NAME,
                transitionSelector: '.css-t2npoc-container'
            }
        ],
        closeAction: [
            {
                actionDispatch: hideDialog,
                actionName: 'hideDialog'
            }
        ]
    },
    'popupNoiseSupp': {
        title: 'Select type of noise suppression',
        'selector': '.noise-tab',
        'tooltipPosition': {
            placement: 'auto'
        },
        scrollToElement: true,
        runAction: [
            {
                actionDispatch: openSettingsDialog,
                actionName: 'openSettingsDialog',
                params: ADVANCED_TAB_NAME,
                transitionSelector: '.css-t2npoc-container'
            }
        ],
        closeAction: [
            {
                actionDispatch: hideDialog,
                actionName: 'hideDialog'
            }
        ]
    },
    'sidebarSize': {
        title: 'Sidebar size',
        'selector': '.dragHandle',
        'tooltipPosition': {
            placement: 'left'
        },
        toggleCustomClass: [
            {
                className: '.dragHandleContainer',
                addClassName: 'visible',
                removeClassName: 'visible'
            }
        ],
        runAction: [
            {
                actionDispatch: setFilmstripVisible,
                actionName: 'setFilmstripVisible',
                params: true,
                getSateFromStore: {
                    name: 'features/filmstrip',
                    value: 'visible',
                    compareState: false
                },
                transitionSelector: '.filmstrip'
            },
            {
                actionDispatch: setTileView,
                actionName: 'setTileView',
                params: false,
                getSateFromStore: {
                    name: 'features/video-layout',
                    value: 'tileViewEnabled',
                    compareState: [ true, undefined ]
                },
                transitionDelay: 200
            }
        ]
    },
    'pinParticipant': {
        title: 'Pin a user',
        'selector': '.filmstrip',
        'tooltipPosition': {
            placement: 'left'
        },
        runAction: [
            {
                actionDispatch: setFilmstripVisible,
                actionName: 'setFilmstripVisible',
                params: true,
                getSateFromStore: {
                    name: 'features/filmstrip',
                    value: 'visible',
                    compareState: false
                },
                transitionSelector: '.filmstrip'
            },
            {
                actionDispatch: setTileView,
                actionName: 'setTileView',
                params: false,
                getSateFromStore: {
                    name: 'features/video-layout',
                    value: 'tileViewEnabled',
                    compareState: [ true, undefined ]
                },
                transitionDelay: 200
            }
        ],
        toggleCustomClass: [
            {
                className: '.resizable-filmstrip',
                cssStyleAdd: 'background: rgba(152,165,174,.12)!important;backdrop-filter: blur(22px);',
                cssStyleRemove: [ 'background', 'backdrop-filter' ]
            },
            {
                className: '.toolbox-content',
                cssStyleAdd: 'opacity: 0;',
                cssStyleRemove: [ 'opacity' ]
            }
        ]
    },
    'maxPinnedUsers': {
        title: 'Max number of pinned users',
        'selector': '#more-maxStageParticipants-select',
        'tooltipPosition': {
            placement: 'auto'
        },
        scrollToElement: true,
        runAction: [
            {
                actionDispatch: openSettingsDialog,
                actionName: 'openSettingsDialog',
                params: SETTINGS_TABS.MORE,
                transitionSelector: '.css-t2npoc-container'
            }
        ],
        closeAction: [
            {
                actionDispatch: hideDialog,
                actionName: 'hideDialog'
            }
        ]
    },
    'noiseSuppression': {
        title: 'Noise suppression',
        'selector': '#noiseSuppressionLabel',
        'tooltipPosition': {
            placement: 'auto'
        },
        runAction: [
            {
                actionDispatch: setTileView,
                actionName: 'setTileView',
                params: false,
                getSateFromStore: {
                    name: 'features/video-layout',
                    value: 'tileViewEnabled',
                    compareState: [ true, undefined ]
                }
            }
        ]
    },
    'whiteboard': {
        title: 'Whiteboard',
        'selector': '.whiteboard',
        'tooltipPosition': {
            placement: 'auto'
        },
        scrollToElement: true,
        runAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: true,
                transitionDelay: 300,
                getSateFromStore: {
                    name: 'features/toolbox',
                    value: 'overflowMenuVisible',
                    compareState: false
                }
            }
        ],
        closeAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: false
            }
        ]
    },
    'endConferenceForAll': {
        title: 'End conference for all user',
        'selector': '.popover .endconference',
        'tooltipPosition': {
            placement: 'auto'
        },
        typeRole: PARTICIPANT_ROLE.MODERATOR,
        scrollToElement: true,
        runAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: true,
                transitionDelay: 300,
                getSateFromStore: {
                    name: 'features/toolbox',
                    value: 'overflowMenuVisible',
                    compareState: false
                }
            }
        ],
        closeAction: [
            {
                actionDispatch: setOverflowMenuVisible,
                actionName: 'setOverflowMenuVisible',
                params: false
            }
        ]
    },
    'advanceTabAutoPip': {
        title: 'Start PiP (picture-in-picture) Automatically',
        'selector': '.auto-pip-checkbox',
        'tooltipPosition': {
            placement: 'auto'
        },
        scrollToElement: true,
        runAction: [
            {
                actionDispatch: openSettingsDialog,
                actionName: 'openSettingsDialog',
                params: ADVANCED_TAB_NAME,
                transitionSelector: '.css-t2npoc-container'
            }
        ],
        closeAction: [
            {
                actionDispatch: hideDialog,
                actionName: 'hideDialog'
            }
        ]
    },

    // Unused
    'unpinButtonHW': {
        title: 'Toggle full screen',
        'selector': '.wizyconf-unpin-button',
        'tooltipPosition': {
            placement: 'top'
        }
    }
};
